module.exports = __webpack_public_path__ + "img/Indian-Creek.ecc24036.jpg";